import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Constants } from '../helpers';

@Injectable()
export class ImportDataService {
	constructor(private http: HttpClient) {}

	/**
	 * Imports data from the given csv file.
	 * @param file
	 * @param importDataType
	 * @param tags
	 */
	public importData(file, importDataType: string, tags: string[]) {
		const formData = new FormData();
		formData.append('file', file);
		formData.append('importDataType', importDataType);
		if (tags && tags.length) {
			formData.append('tags', JSON.stringify(tags));
		}

		return this.http.post<{
			importStatus: boolean;
			importMessage: string;
			importErrors: string[];
			importResult: string;
		}>(`${Constants.BASE_API_URL}/import-data/`, formData);
	}
}
